import { useEffect } from "react";
import { useParams, useNavigate } from "react-router";
import { storeReferralCode } from "@/lib/referral";
import { useAuth } from "@/lib/auth-context";

export function ReferralCapture() {
  const { code } = useParams<{ code: string }>();
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (code) {
      storeReferralCode(code);
    }
    // If already logged in, go to referral page; otherwise, go to register
    if (user) {
      navigate("/referral", { replace: true });
    } else {
      navigate("/register", { replace: true });
    }
  }, [code, user, navigate]);

  return null;
}
